/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// Null guard: prevent Safari crash on products with no variant selector
// Fixes: "null is not an object (evaluating 'document.querySelector(".productform__selectedvalue").textcontent')"
// Affected: ceramic blossoms and any other single-option products without variant dropdowns
document.addEventListener('DOMContentLoaded', function() {
  if (!document.querySelector('.productform__selectedvalue')) {
    var placeholder = document.createElement('span');
    placeholder.className = 'productform__selectedvalue';
    placeholder.style.display = 'none';
    document.body.appendChild(placeholder);
  }
});